import styled from "styled-components";

export const Title = styled.span<{ $size?: number; $ml?: number }>`
    font-size: ${({ $size = 50 }) => `${$size}px`};
    font-weight: 700;
    color: #ffffff;
    margin-left: ${({ $ml = 8 }) => `${$ml}px`};
`;

export const DescriptionSection = styled.div`
    gap: 12px;
    display: flex;
    flex-direction: column;
    height: auto;
    margin-bottom: 36px;
`;

export const TitleCard = styled.div<{ $mb?: number }>`
    font-weight: 700;
    font-size: 25px;
    line-height: 30px;
    color: #000;
    margin-top: 24px;
    margin-bottom: ${({ $mb = 0 }) => `${$mb}px`};
`;

export const CardText = styled.div`
    font-size: 16px;
    line-height: 24px;
    color: #000;
    margin-top: 12px;
`;

export const BadgeArea = styled.div`
    position: absolute;
    top: 12px;
    left: 16px;
    width: fit-content;
    padding: 2px 12px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    border-radius: 10px;
    font-weight: 700;
    z-index: 1;

    @media (max-width: 480px) {
        top: 6px;
        left: 6px;
    }

`;

export const PriceCard = styled.div`
    position: relative;
    overflow: hidden;            
    background-color: #fff;
    border-radius: 12px;
    height: auto;
    width: 350px;
    min-width: 350px;
    max-width: 350px;
    padding: 20px;
    margin: auto;
    display: flex;
    flex-direction: column;
    text-align: center;
    flex: 0 0 350px;

    @media (max-width: 480px) {
        padding: 0;
    }
`;

export const DarkSection = styled.div`
    background: #181a1d;
    margin: 0 -20px -20px;         
    padding: 24px 20px 20px;
    border-bottom-left-radius: 12px;  
    border-bottom-right-radius: 12px;

    @media (max-width: 480px) {
        margin: 0;

    }
`;

export const Wrapper = styled.div`
    display: flex;
    gap: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }
`;

export const PriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin: 0;
`;

export const WrapperButton = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 30px;
`;

export const PriceRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

export const CurrencySymbol = styled.span<{
    $size?: number;
    $mt?: number;
    $ml?: number;
}>`
    font-size: ${({ $size = 24 }) => `${$size}px`};
    font-weight: 700;
    color: #fff;
    margin-left: ${({ $ml = 8 }) => `${$ml}px`};
    margin-top: ${({ $mt = 0 }) => `${$mt}px`};
`;

export const PriceTerm = styled.span`
    font-size: 14px;
    color: #fff;
    align-self: flex-end;
    margin-bottom: 8px;
`;

export const SetupText = styled.div`
    border-top: 1px solid #fff;
    padding-top: 16px;
    display: flex;
    align-items: baseline;
    gap: 12px;
    font-size: 14px;
    color: #fff;
    margin: 0;

    @media (max-width: 480px) {
        padding-top: 12px;
    }
`;

export const SetupTitle = styled.span`
    font-size: 14px;
    color: #fff;
    align-self: flex-end;
    margin-bottom: 4px;

    @media (max-width: 480px) {
        align-self: center;
    }
`;

export const MoneyGroup = styled.div`
    display: flex;
    gap: 6px;
`;
